import { Badge } from 'react-bootstrap';
import type { Questionnaire, QuestionnaireStatus } from '../../../infrastructure/QuestionnaireClient';

interface SurveyHeaderProps {
  survey: Questionnaire | null;
  title?: string | undefined;
}

const statusVariant = (status: QuestionnaireStatus): string => {
  if (status === 'published') return 'success';
  if (status === 'archived') return 'secondary';
  return 'warning';
};

export function SurveyHeader({ survey, title }: SurveyHeaderProps) {
  return (
    <div className="d-flex flex-wrap align-items-start justify-content-between gap-3 mb-3">
      <div>
        <h1 className="h3 mb-1">{title ?? survey?.title ?? 'Survey'}</h1>
        {survey && (
          <div className="text-muted small">
            <span className="font-monospace">{survey.surveyUuid}</span>
            <span className="mx-2">|</span>
            <span>v{survey.latestVersion?.version ?? '-'}</span>
          </div>
        )}
      </div>
      {survey && <Badge bg={statusVariant(survey.status)}>{survey.status}</Badge>}
    </div>
  );
}
